import { React, useState, useEffect } from "react";

import { useSelector } from "react-redux";

import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";

import { Line } from "rc-progress";
import { useDispatch } from "react-redux";

import {
  ApiUpdateDefishieldInvestmentRisks,
  ApiUpdateLightDefiAlert,
  ApiUpdateLightNTFAlert,
  ApiUpdatePartnerGuardAlert,
  ApiUpdateStakingRiskAlert,
  ApiUpdateWalletAlert,
} from "../../Api";

import { DefiShildInvestmentRiskAlertThunk } from "../../Thunks/DefiShildInvestmentRiskAlertThunk";
import { LightDefiInvestmentRiskAlertThunk } from "../../Thunks/LightDefiInvestmentRiskAlertThunk";
import { LighNTFInvestmentRiskAlertThunk } from "../../Thunks/LightNTFInvestmentRiskAlertThunk";
import { PartnerGuardInvestmentRiskAlertThunk } from "../../Thunks/PartnerGuardInvestmentAlertThunk";
import { WalletInvestmentRiskAlertThunk } from "../../Thunks/WalletInvestmentRiskAlertThunk";
import {
  StakingRiskRiskAlertThunk,
  UpdateStakingRiskInvestmentAlertThunk,
} from "../../Thunks/StakingRiskThunk";

export function LastMounthDefiCard({ element, title }) {
  const dispach = useDispatch();

  const [openProgress, setOpenProgress] = useState(false);
  const [alertvalue, setValue] = useState(0);

  const investmentRiskAlertResult = useSelector((state) => {
    return state.defiShildInvestmentRiskAlert.investment_risk_alert_result;
  });

  const lightDefiInvestmentRiskAlertResult = useSelector((state) => {
    return state.lightDefiInvestmentRiskAlert
      .lightDefiInvestmentRiskAlertResult;
  });

  const lightNTFinvestmentRiskAlertResult = useSelector((state) => {
    return state.lightNTFInvestmentRiskAlertReducer
      .lightntfInvestmentRiskAlertResult;
  });

  const partnerGuardinvestmentRiskAlertResult = useSelector((state) => {
    return state.partnerGuardInvestmentRiskAlertReducer
      .partnerGuardInvestmentRiskAlertResult;
  });

  const walletinvestmentRiskAlertResult = useSelector((state) => {
    return state.WalletInvestmentRiskAlertReducer
      .walletInvestmentRiskAlertResult;
  });
  const stakingRiskInvestmentRiskAlertResult = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskInvestmentRiskAlertResult;
  });

  const handleChange = (value, e) => {
    //e.preventDefault()
    setValue(value);
  };

  // const renderClassName = (color) => {
  //   switch (color) {
  //     case "green":
  //       return {
  //         stroke: "#4DC7B5",
  //       };
  //     case "yellow":
  //       return {
  //         stroke: "#EFB661",
  //       };
  //     case "red":
  //       return {
  //         stroke: "#F27281",
  //       };

  //     default:
  //       return {
  //         stroke: "#F27281",
  //       };
  //   }
  // };

  const coldprops = {
    percent: Math.round(element?.lastMonthPortfolioRisk), // is require
    colorSlice: "#4DC7B5",
    fontColor: "#4DC7B5",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 178,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const riskprops = {
    percent: Math.round(element?.lastMonthPortfolioRisk), // is require
    colorSlice: "#EFB661",
    fontColor: "#EFB661",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 178,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const holdprops = {
    percent: Math.round(element?.lastMonthPortfolioRisk), // is require
    colorSlice: "#F27281",
    fontColor: "#F27281",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 178,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const whiteprops = {
    percent: 0, // is require
    colorSlice: "#f0f0f3",
    fontColor: "#f0f0f3",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 178,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const renderClassName = (safetyIndex) => {
    if (safetyIndex >= 65 && safetyIndex <= 100) {
      return {
        className: "card cold defi", // green
        stroke: "#4dc7b5",
        props: coldprops,
      };
    } else if (safetyIndex >= 31 && safetyIndex <= 64) {
      return {
        className: "card hold defi", // yellow
        stroke: "#EFB661",
        props: riskprops,
      };
    } else if (safetyIndex >= 0 && safetyIndex < 31) {
      return {
        className: "card risky defi", // red
        stroke: "#F27281",
        props: holdprops,
      };
    } else {
      return {
        className: "card empty defi",
        stroke: "#C4C4C4",
        props: whiteprops,
      };
    }
  };
  const alertOnChangeComplete = () => {
    if (title === "defiShild") {
      ApiUpdateDefishieldInvestmentRisks(+alertvalue, 4)
        .then((result) => {
          dispach(DefiShildInvestmentRiskAlertThunk());
        })
        .catch((error) => {});
    } else if (title === "lightDefi") {
      ApiUpdateLightDefiAlert(+alertvalue, 4)
        .then((result) => {
          dispach(LightDefiInvestmentRiskAlertThunk());
        })
        .catch((error) => {});
    } else if (title === "lightNTF") {
      ApiUpdateLightNTFAlert(+alertvalue, 4)
        .then((result) => {
          dispach(LighNTFInvestmentRiskAlertThunk());
        })
        .catch((error) => {});
    } else if (title === "partnerGuard") {
      ApiUpdatePartnerGuardAlert(+alertvalue, 4)
        .then((result) => {
          dispach(PartnerGuardInvestmentRiskAlertThunk());
        })
        .catch((error) => {});
    } else if (title === "wallet") {
      ApiUpdateWalletAlert(+alertvalue, 4)
        .then((result) => {
          dispach(WalletInvestmentRiskAlertThunk());
        })
        .catch((error) => {});
    } else if (title === "stakingRisk") {
      //dispach(UpdateStakingRiskInvestmentAlertThunk(+alertvalue, 4));
      ApiUpdateStakingRiskAlert(+alertvalue, 4)
        .then((result) => {
          dispach(StakingRiskRiskAlertThunk());
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    if (investmentRiskAlertResult.length && title === "defiShild") {
      investmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [investmentRiskAlertResult, title]);

  useEffect(() => {
    if (lightDefiInvestmentRiskAlertResult.length && title === "lightDefi") {
      lightDefiInvestmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [lightDefiInvestmentRiskAlertResult, title]);

  useEffect(() => {
    if (lightNTFinvestmentRiskAlertResult.length && title === "lightNTF") {
      lightNTFinvestmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [lightNTFinvestmentRiskAlertResult, title]);

  useEffect(() => {
    if (
      partnerGuardinvestmentRiskAlertResult.length &&
      title === "partnerGuard"
    ) {
      partnerGuardinvestmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [partnerGuardinvestmentRiskAlertResult, title]);

  useEffect(() => {
    if (walletinvestmentRiskAlertResult.length && title === "wallet") {
      walletinvestmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [walletinvestmentRiskAlertResult, title]);

  useEffect(() => {
    if (
      stakingRiskInvestmentRiskAlertResult?.length &&
      title === "stakingRisk"
    ) {
      stakingRiskInvestmentRiskAlertResult?.map((element) => {
        if (element && element.type && element.type === 4) {
          setValue(+element.alert);
        }
      });
    }
  }, [stakingRiskInvestmentRiskAlertResult, title]);
  return (
    <>
      <div className="aside__card cold">
        <div className="row">
          <div className="aside__card__left">
            <h3 className="aside__card__title">
              {title === "lightNTF"
                ? "NFT Portfolio Value"
                : title === "partnerGuard"
                ? "Counterparties Risk"
                : "Portfolio  Risk"}
            </h3>
            {element?.lastMonthInvestmentRisk ? (
              <p className="aside__card__numbers">
                {Math.round(element?.lastMonthInvestmentRisk)}/<span>100</span>
              </p>
            ) : element?.lastMonthPortfolioRisk >= 0 &&
              title === "stakingRisk" ? (
              <p className="aside__card__numbers">
                {Math.round(element?.lastMonthPortfolioRisk)}/<span>100</span>
              </p>
            ) : (
              <p className="aside__card__numbers">
                {"--"}/<span>100</span>
              </p>
            )}
          </div>
          <div
            className={
              "card__risk__alert" +
              " " +
              (openProgress ? "active" : "card__risk__alert")
            }
            onClick={() => {
              if (openProgress) {
                alertOnChangeComplete();
              }
              setOpenProgress(!openProgress);
            }}
          >
            <p className="card__risk__alert__title">Alert</p>
            <p
              className={
                "card__risk__alert__number" +
                " " +
                (alertvalue === 0 || null
                  ? "card__risk__alert__not_number"
                  : "card__risk__alert__number")
              }
            >
              {alertvalue}
            </p>
          </div>
          {openProgress ? (
            <div
              className={
                "card__risk__range__hr active current__card investment_card" +
                " " +
                (alertvalue === 0 || null
                  ? "horizontal_slid_nit_value investment_card"
                  : "card__risk__range__hr active current__card investment_card")
              }
            >
              <Slider
                min={0}
                max={100}
                value={alertvalue}
                orientation="horizontal"
                onChange={handleChange}
                tooltip={false}
                onChangeComplete={alertOnChangeComplete}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <Line
          percent={Math.round(
            element?.lastMonthInvestmentRisk || element?.lastMonthPortfolioRisk
          )}
          strokeWidth={4}
          strokeColor={
            // renderClassName(
            //   element?.lastMonthInvestmentRiskTrustScore ||
            //     element?.lastMonthPortfolioRiskTrustScore
            // )?.stroke
            renderClassName(
              element?.lastMonthInvestmentRiskTrustScore ||
                element?.lastMonthPortfolioRisk
            )?.stroke
          }
          className="aside__card__progress"
        />
      </div>
    </>
  );
}
